import { EventBroker } from "@frontend/lib/utils/event-broker";

export const RENAME_LAYOUT_EVENTS = {
  INIT: 'INIT',
  SAVE: 'SAVE',
  SAVED: 'SAVED',
}

export const renameLayoutEventBroker = new EventBroker()
